import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { C } from '../constants';
import { ScrollView, Platform } from 'react-native';


class AppScrollView extends Component {
  componentDidUpdate(prevProps) {
    if (prevProps.appStatus !== this.props.appStatus && this.props.appStatus === "loaded" && C.FIXED_HEADER) {
      this.scrollToTop();
    }
  }

  scrollToTop = () => {
    setTimeout(()=>{
      
      this.scroller.scrollTo({ x: 0, y: 0 });
      if (Platform.OS === 'web') {
        window.scrollTo(0, 0);
      }
    },200);
  };

  render() {
    let { children } = this.props;

    return (
      C.FIXED_HEADER ?
        <ScrollView ref={(scroller) => { this.scroller = scroller; }}>{children}</ScrollView> :
        <>{children}</>
    );
  }
}

function mapStateToProps(state) {
  return {
    appStatus: state.appStatus
  };
}

AppScrollView.propTypes = {
  appStatus: PropTypes.string,
  children: PropTypes.any
};

export default connect(mapStateToProps)(AppScrollView);
